/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TrashSolidSmall2(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TrashSolidSmall2',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 13 * scale,
      viewBox: '0 0 12 13',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M2 11a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6H2zm8-9H8a1 1 0 0 1-1-1H5a1 1 0 0 1-1 1H1v2h10V2z"}))
}
